var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"contentpdf"},[_c('headerbar',{attrs:{"curindex":1}}),_c('div',{staticClass:"contentpdf_ifrm"},[_c('iframe',{attrs:{"src":_vm.file,"width":"100%","height":"100%"}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }